import { render } from "./expand-info.vue?vue&type=template&id=11b82811&scoped=true"
import script from "./expand-info.vue?vue&type=script&lang=js"
export * from "./expand-info.vue?vue&type=script&lang=js"

import "./expand-info.vue?vue&type=style&index=0&id=11b82811&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b82811"]])

export default __exports__